// Custom throttle function to limit the frequency of function calls
function throttle(func, wait) {
  let timeout = null;
  let previous = 0;

  return function (...args) {
    const now = Date.now();
    const remaining = wait - (now - previous);

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(this, args);
    } else if (!timeout) {
      timeout = setTimeout(() => {
        previous = Date.now();
        timeout = null;
        func.apply(this, args);
      }, remaining);
    }
  };
}

// Store the original header height
let originalHeaderHeight = 0;
let isInitialized = false;

// Function to calculate the initial header height
const calculateInitialHeaderHeight = function () {
  const header = document.querySelector(".header");
  if (header) {
    // Temporarily remove scrolling class to get accurate initial height
    const hasScrollingClass = header.classList.contains("scrolling");
    if (hasScrollingClass) {
      header.classList.remove("scrolling");
    }

    // Force browser to recalculate layout before measuring
    void header.offsetHeight; // This triggers a reflow

    originalHeaderHeight = header.offsetHeight;
    console.log("Original header height:", originalHeaderHeight);

    // Update CSS variable with original height
    document.documentElement.style.setProperty(
      "--header-height",
      `${originalHeaderHeight}px`
    );

    // Restore class if it was there
    if (hasScrollingClass) {
      header.classList.add("scrolling");
    }

    isInitialized = true;
  }
};

// Function to handle scrolling without throttling
function handleScroll() {
  if (!isInitialized) {
    calculateInitialHeaderHeight();
  }

  const header = document.querySelector(".header");
  const scrollPosition = window.scrollY;

  // Use the original header height for scroll comparison
  if (scrollPosition >= originalHeaderHeight) {
    if (!header.classList.contains("scrolling")) {
      header.classList.add("scrolling");
    }
  } else {
    if (header.classList.contains("scrolling")) {
      header.classList.remove("scrolling");

      // When returning to top, update height variable again to ensure it's correct
      // Wait a small amount of time for any CSS transitions to complete
      setTimeout(() => {
        document.documentElement.style.setProperty(
          "--header-height",
          `${originalHeaderHeight}px`
        );
      }, 50);
    }
  }
}

// Use throttled version for scroll events
const trackHeaderHeight = throttle(handleScroll, 50); // Reduced to 50ms for better responsiveness

// Non-throttled version for critical events
function forceHeaderHeightUpdate() {
  calculateInitialHeaderHeight();
  handleScroll();
}

// Attach the throttled scroll event
window.addEventListener("scroll", trackHeaderHeight);

// Attach the resize event without throttling for immediate response
window.addEventListener("resize", forceHeaderHeightUpdate);

// Initialize on DOMContentLoaded for faster initial calculation
document.addEventListener("DOMContentLoaded", forceHeaderHeightUpdate);

// Also initialize on load in case images affect layout
window.addEventListener("load", forceHeaderHeightUpdate);
